import controller from './quota-exceeded.controller';
import '../student.less';

export default {
  controller,
  template: require('./quota-exceeded.html')
};



// WEBPACK FOOTER //
// src/app/components/student/quota-exceeded/quota-exceeded.component.ts